module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[14]501.80045dc.woff2";